function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}var _foods = {};

export var UnitRangeService = /*#__PURE__*/function () {UnitRangeService.$inject = ["$http", "$q", "gplansConf"];
  function UnitRangeService($http, $q, gplansConf) {
    "ngInject";_classCallCheck(this, UnitRangeService);
    this.$http = $http;
    this.$q = $q;
    this.gplansConf = gplansConf;
  }_createClass(UnitRangeService, [{ key: "getUnitsRange", value: function getUnitsRange()

    {
      if (Object.keys(_foods).length) {
        return this.$q.resolve(_foods);
      } else
      {
        return this.$http.get(this.gplansConf.API_URL + '/api/v1/foods/amount-settings/').then(function (res) {
          for (var i = 0; i < res.data.length; i++) {
            var food = res.data[i];
            _foods[food.food_name] = food;
          }
          return _foods;
        });
      }
    } }, { key: "prepareMealPlanToFractional", value: function prepareMealPlanToFractional(

    mealPlan, mesSystem) {
      for (var dayIndex = 0; dayIndex < mealPlan.days.length; dayIndex++) {
        var day = mealPlan.days[dayIndex];
        for (var mealIndex = 0; mealIndex < day.meals.length; mealIndex++) {
          var meal = day.meals[mealIndex];
          for (var k = 0; k < meal.meal_items.length; k++) {
            var meal_item = meal.meal_items[k];
            meal_item.range = [];
            if (['extra', 'free'].indexOf(meal_item.category) == -1 && mesSystem == 'US' && _foods.hasOwnProperty(meal_item.name)) {
              var foodRange = _foods[meal_item.name];
              meal_item.range = foodRange.range;
              meal_item.representation_type = foodRange.representation_type;
            }
          }
          for (var _k = 0; _k < meal.logged_meal_items.length; _k++) {
            var _meal_item = meal.logged_meal_items[_k];
            _meal_item.range = [];
            if (['extra', 'free'].indexOf(_meal_item.category) == -1 && mesSystem == 'US' && _foods.hasOwnProperty(_meal_item.name)) {
              var _foodRange = _foods[_meal_item.name];
              _meal_item.range = _foodRange.range;
              _meal_item.representation_type = _foodRange.representation_type;
            }
          }
        }
      }
      return mealPlan;
    } }, { key: "getFractional", value: function getFractional(

    value) {
      value = value.toFixed(2).split('.');
      var fractional = '';
      var value1 = parseInt(value[1]);
      if (value1 == '25') {fractional = '1/4';} else
      if (value1 == '33' || value1 == '32') {fractional = '1/3';} else
      if (value1 == '5' || value1 == '50') {fractional = '1/2';} else
      if (value1 == '66' || value1 == '65') {fractional = '2/3';} else
      if (value1 == '75') {fractional = '3/4';} else
      if (value1 == '99') {fractional = '1';}
      if (value[0] == '0') {
        value = fractional;
      } else
      {
        value = value[0] + ' ' + fractional;
      }
      return value;
    } }]);return UnitRangeService;}();